import type { SVGProps } from 'react';

export const YoutubeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='13' height='10' viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M12.2388 1.36625C12.095 0.82875 11.6712 0.405 11.1337 0.26125C10.1587 1.30385e-07 6.25 0 6.25 0C6.25 0 2.34125 1.30385e-07 1.36625 0.26125C0.82875 0.405 0.405 0.82875 0.26125 1.36625C-1.86265e-08 2.34125 0 5 0 5C0 5 -1.86265e-08 7.65875 0.26125 8.63375C0.405 9.17125 0.82875 9.595 1.36625 9.73875C2.34125 10 6.25 10 6.25 10C6.25 10 10.1587 10 11.1337 9.73875C11.6719 9.595 12.095 9.17125 12.2388 8.63375C12.5 7.65875 12.5 5 12.5 5C12.5 5 12.5 2.34125 12.2388 1.36625ZM5 6.62375V3.37625C5 3.13563 5.26062 2.98563 5.46875 3.10562L8.28125 4.72938C8.48938 4.84938 8.48938 5.15062 8.28125 5.27062L5.46875 6.89437C5.26062 7.015 5 6.86437 5 6.62375Z'
      fill='black'
    />
  </svg>
);
